import { useEffect } from 'react'
import Store from 'redux/Store'
import { getAllCustomData } from 'shared/components/App/Auth'
import { setCustomData, setLastUrl, setMenuPages } from 'shared/redux/actions'
import processCustomerChange from '../utils/processCustomerChange'
import { setCustomerName, setSettings } from 'redux/actions'
import { apiUrls } from 'consts'
import getAll from 'utils/getAll'
import loadPages from 'utils/loadPages'

interface useInitCentersProps {
  currentCustomer: any
  initialRender: boolean
  dataLoaded: boolean
  setInitialRender: Function
  handleCustomerChanged?: Function
}

const useCustomerChange = (props: useInitCentersProps) => {

  useEffect(() => {
    if (!props.initialRender && props.dataLoaded) {
      processCustomerChange({
        customer_id: props.currentCustomer?.id,
        setShowOverlay: (data) => { },
      }).then((data: any) => {

        //get new settings
        getAll(apiUrls.settings).then(settingsData => {
          Store.dispatch(setSettings(settingsData))

          const allCustomData = getAllCustomData()
          allCustomData.customer = props.currentCustomer
          Store.dispatch(setCustomData(allCustomData))
          Store.dispatch(setCustomerName(allCustomData.customer.name))

          // load user pages
          loadPages({
            role: allCustomData.role,
            customer: allCustomData.customer,
            loadFromServer: true
          }).then((pages) => {
            Store.dispatch(setMenuPages(pages))

            // reset page to navigate to on user side
            let lastUrl = Store.getState()?.lastUrl.lastUrl
            if (lastUrl === null) {
              lastUrl = {}
            }

            const page = pages.find(item => {
              return item?.path && item.path.length &&
                item?.roles && item.roles.includes('user')
            })

            if (page) {
              console.log('page', page)
              lastUrl['user'] = page.path
              Store.dispatch(setLastUrl(lastUrl))
            }
          })

          if (props.handleCustomerChanged !== undefined) {
            props.handleCustomerChanged(props.currentCustomer)
          }

          Store.dispatch(setCustomerName(props.currentCustomer.name))
        })
      })
    } else {
      props.setInitialRender(false)
    }
  }, [props.currentCustomer])
}

export default useCustomerChange
